export const withoutTransportWideCongestionControl = (sdp: RTCSessionDescriptionInit): RTCSessionDescriptionInit => {
    return {
        type: sdp.type,
        sdp: sdp
            .sdp!
            .split("\r\n")
            .filter(line => !(line.includes("transport-cc") || line.includes("http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01")))
            .join("\r\n")
    }
}